import { useSearchParams } from 'react-router-dom';

// TODO: we'll need to clean up the Feature Flag in this hook... eventually
const useListingDetailsAndFeedback = ({ fullPageDetails = false }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onListingDetailsClick = (listing) => (event) => {
    event.preventDefault();

    if (!fullPageDetails) {
      searchParams.set('listing_id', listing.slug);
      setSearchParams(searchParams, {
        preventScrollReset: true,
        replace: true,
      });
    } else {
      window.location = `/listings/show/${listing.slug}`;
    }
  };

  const onListingFeedbackClick = (listing) => (event) => {
    event.preventDefault();

    if (!fullPageDetails) {
      searchParams.set('feedback_listing_id', listing.slug);
      setSearchParams(searchParams, {
        preventScrollReset: true,
        replace: true,
      });
    } else {
      window.location = `/listings/show/${listing.slug}`;
    }
  };

  return { onListingDetailsClick, onListingFeedbackClick };
};

export default useListingDetailsAndFeedback;
